module.exports = __webpack_public_path__ + "media/giftcards/EGiftCardProductMini-78bbf034.png";